import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeSeedings, getPracticeSeedings } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_SEEDINGS } from "consts";

import { PracticeSeeding, WithInjectedName } from "models";

export const useGetPracticeSeedings = ({ enabled }: { enabled?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getAdminPracticeSeedings : getPracticeSeedings;

  return useQuery<Array<WithInjectedName<PracticeSeeding>>>({
    queryKey: [GET_PRACTICES_SEEDINGS, enabled, isAdmin],
    queryFn: async () => {
      const seedings = await queryFn({ enabled });
      return seedings.map((s) => ({ ...s, name: t(`seedings.${s.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
